import { Navigate, useLocation } from "react-router-dom";
import { useSaasAuth } from "@/saas/context/SaasAuthContext";

export default function SaasProtectedRoute({ children }) {
  const { user, token, loading } = useSaasAuth();
  const loc = useLocation();
  if (loading) return null;
  // /me yüklenmesi başarısızsa user null olur ama token persist edilebilir.
  // İki tarafı da kontrol et — ikisi de yoksa login'e gönder.
  if (!token && !user) {
    return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  }
  return children;
}
